'use client'

import { useEffect } from 'react'
import { handleVersionSkew } from '@/lib/toast'

/**
 * Safety net for server-action version-skew failures that no catch block
 * handles (fire-and-forget calls, future form actions). Caught failures are
 * covered by the toast wrapper in src/lib/toast.ts. Renders nothing; mounted
 * once in the root layout.
 */
export function VersionSkewListener() {
  useEffect(() => {
    const onRejection = (event: PromiseRejectionEvent) => {
      if (handleVersionSkew(event.reason)) event.preventDefault()
    }
    const onError = (event: ErrorEvent) => {
      if (handleVersionSkew(event.error ?? event.message)) event.preventDefault()
    }
    window.addEventListener('unhandledrejection', onRejection)
    window.addEventListener('error', onError)
    return () => {
      window.removeEventListener('unhandledrejection', onRejection)
      window.removeEventListener('error', onError)
    }
  }, [])

  return null
}
